import { CodatAuthContextType } from "@codat/client-cookie-manager";
import { AxiosPromise } from "axios";
import formatUrl from "utils/formatUrl";

import config from "config";
import { api as apiRoutes } from "config/urls";

import makeApi from "./makeApi";
import { Connection } from "./models/Connection";
import { DataSet } from "./models/DataSet";
import { PushOperation } from "./models/PushOperation";
import { PagedResponse } from "./shared";

export interface PublicApi {
  getConnection: (
    companyId: string,
    connectionId: string
  ) => AxiosPromise<Connection>;
  getDataHistory: (
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) => AxiosPromise<PagedResponse<DataSet>>;

  getPushOperations: (
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) => AxiosPromise<PagedResponse<PushOperation>>;
}

export const makePublicApi = (auth: CodatAuthContextType): PublicApi => {
  const instance = makeApi(auth, config.PUBLIC_API_URL);

  const getConnection = (companyId: string, connectionId: string) =>
    instance.get<Connection>(
      formatUrl(apiRoutes.companies.connections.single, {
        companyId,
        connectionId,
      })
    );

  const getDataHistory = (
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) =>
    instance.get<PagedResponse<DataSet>>(
      formatUrl(
        apiRoutes.companies.data.history,
        { companyId },
        { page: pageNumber, pageSize: pageSize }
      )
    );

  const getPushOperations = (
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) =>
    instance.get<PagedResponse<PushOperation>>(
      formatUrl(
        apiRoutes.companies.push.pushOperations,
        { companyId },
        { page: pageNumber, pageSize: pageSize, orderBy: "-requestedOnUtc" }
      )
    );

  return {
    getDataHistory,
    getConnection,
    getPushOperations,
  };
};
